import defs from '../../_core/defs.js';
// tells whether a Matreshka.Object still holds given value under a data key other than exceptKey
export default function isHeldByDataKey(object, value, exceptKey) {
  // a Matreshka.Object always has a definition with data keys
  var _defs$get = defs.get(object),
    keys = _defs$get.keys;
  return Object.keys(keys).some(function (key) {
    return key !== exceptKey && object[key] === value;
  });
}